module.exports = __webpack_public_path__ + "media/images/mobicip_loader-cd44cef707758f565933743f6eeefa26.gif";